// extracted by mini-css-extract-plugin
export var filterIncDec = "_cf-0";
export var leftBorder = "_cf-1";
export var rightBorder = "_cf-2";
export var stringInput = "_cf-3";